import { render } from "./Completed.vue?vue&type=template&id=7198de54&scoped=true"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"

import "./Completed.vue?vue&type=style&index=0&id=7198de54&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/pins/pinsv2/Pins_Queuing_System/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7198de54"]])

export default __exports__